import logo from '../../Assets/Images/rklogo.png'
import React,{useState} from 'react'
import { motion } from 'framer-motion'
import { BsCheckCircleFill } from 'react-icons/bs'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FieldInput from '../../Components/FieldInput'
import Button from '../../Components/Button'
import { useHistory } from 'react-router-dom'
import API from '../../Common/API'
import { useDispatch, useSelector } from 'react-redux'
import { setLoggedIn, setUserDetails, setToken, setAccountType } from '../../Store/Auth/actions'
import { useTranslation } from 'react-i18next'
import { setAlert } from '../../Store/Theme/actions'
import Dialog from '../../Components/Dialog'
import OTPField from '../../Components/OTPField'

const initialMobileForm = {
    mobileNumber: ''
}

const initialPassForm = {
    newPassword : '',
    confirmPassword : ''
}


const ForgotPassword = () => {

     const history = useHistory()
        const dispatch = useDispatch()
        const sellerCreation = useSelector((state) => state.auth.sellerCreation)
        const { t } = useTranslation()
        const [mobForm,setMobForm] = useState(true)
        const [enableOTP,setEnableOTP] = useState(false)
        const [submitDisable,setSubmitDisable] = useState(false)

    const mobileFormSchema = Yup.object().shape({
        mobileNumber : Yup.string().required("Mobile Number is required")
    })

    const mobileForm = useFormik({
        initialValues:initialMobileForm,
        validateOnMount : true,
        validationSchema: mobileFormSchema,
        enableReinitialize: true,
        onSubmit:(values)=>{
            try{
                API.post('/common/requestOTP',values).then((otpRes)=>{
                    if(otpRes.status === 200){
                        dispatch(setAlert({title:'Success',subtitle:'Otp generated successfully',active:true,type:'success'}))
                        setEnableOTP(true)
                    }
                }).catch((err)=>{
                    dispatch(setAlert({title:'Error',subtitle:err.response.data.error.message,active:true,type:'error'}))
                    mobileForm.resetForm()
                })
            }catch(err){
                console.log(err)
            }
        }
    })

    const passwordFormSchema = Yup.object().shape({
        newPassword : Yup.string().required("Password is required"),
        confirmPassword : Yup.string().required("Confirm password is required")
    })

    const passForm = useFormik({
        initialValues : initialPassForm,
        validateOnMount: true,
        validationSchema : passwordFormSchema,
        enableReinitialize: true,
        onSubmit:(values)=>{
            if(values.newPassword !== values.confirmPassword){
                dispatch(setAlert({title:'Error',subtitle:'Password and confirm password should match',active:true,type:'error'}))
            }else{
                setSubmitDisable(true)
                let apiValues = {
                    mobileNumber : mobileForm.values.mobileNumber,
                    password : values.newPassword
                }
                try{
                    API.post('/auth/changePassword',apiValues).then((passRes)=>{
                        if(passRes.status === 200){
                            dispatch(setAlert({title:'Success',subtitle:'Password changed successfully',active:true,type:'success'}))
                            passForm.resetForm()
                            history.push('/auth/login')
                            setSubmitDisable(false)
                        }
                    }).finally(()=>{
                        setSubmitDisable(false)
                    })
                }catch(err){
                    console.log(err)
                }
            }
        }
    })

    const close = ()=>{
        setMobForm(false)
        setEnableOTP(false)
    }

    return (
       <div className="w-full h-screen flex items-center justify-center">
            <div className="w-1/2 hidden lg:inline-flex h-full text-black">
                <div className="w-[450px] h-full bg-primeColor/20 px-10 flex flex-col gap-6 justify-center">
                    <img src={logo} alt="logoImg" className="w-28" onClick={() => history.push('/')} />
                    <div className="flex flex-col gap-1 -mt-1">
                        <h1 className="font-titleFont text-xl font-medium">
                            {t('Stay sign in for more')}
                        </h1>
                        <p className="text-base">{t('When you sign in, you are with us!')}</p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Get started fast with Royalkavery')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Access all Royalkavery services')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Trusted by online Shoppers')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="flex items-center justify-between mt-10">
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            © Royalkavery
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Terms')}
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Privacy')}
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Security')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="w-full md:w-1/2 grid grid-cols-1 gap-10 items-center justify-center">
                <motion.div className="w-full md:w-80 flex flex-col cursor-pointer items-center justify-center" onClick={() => history.push('/')}>
                    <img src={logo} height={100} width={100} alt="logo" onClick={() => history.push('/')} />
                </motion.div>
                <motion.div className="grid grid-cols-1 w-96">
                    <FieldInput type='phone' label={"Enter your registered mobile number"} fieldHelper={mobileForm.getFieldHelpers('mobileNumber')} fieldMeta={mobileForm.getFieldMeta('mobileNumber')} fieldProps={mobileForm.getFieldProps('mobileNumber')} edit={mobForm} dataLoaded={mobForm}/>
                    {!mobForm && <FieldInput type="password" label={"New Password"} fieldHelper={passForm.getFieldHelpers('newPassword')} fieldMeta={passForm.getFieldMeta('newPassword')} fieldProps={passForm.getFieldProps('newPassword')} edit={true} dataLoaded={true}/>}
                    {!mobForm && <FieldInput type="password" label={"Confirm Password"} fieldHelper={passForm.getFieldHelpers('confirmPassword')} fieldMeta={passForm.getFieldMeta('confirmPassword')} fieldProps={passForm.getFieldProps('confirmPassword')} edit={true} dataLoaded={true}/>}
                    <Button type={'primary'} injectClass={'bg-primeColor rounded-full ring ring-primeColor'} onClick={()=> mobForm ? mobileForm.submitForm() : !submitDisable && passForm.submitForm()}>{mobForm ? 'Send OTP' : 'Change Password'}</Button>
                </motion.div>
            </div>
            <Dialog showDialog={enableOTP} title={"OTP Verification"} onClose={()=>setEnableOTP(false)}>
                <OTPField mobileNumber= {mobileForm.values.mobileNumber} onSucess={(ev) => ev && close()} onAbort={() => mobileForm.resetForm()}/>
            </Dialog>
        </div>
    )
}

export default ForgotPassword